import styled from "styled-components";
import { Button } from "react-rainbow-components";
import BackgroundPattern from "../../img/bg_pattern_white.png";
import { Form } from "react-bootstrap";
import breakpoint from "../../assets/breakpoints";
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(9, 132, 227, 0.8);
  background-image: url(${BackgroundPattern});
  background-position: 50%;
  background-size: 600px;
  font-family: "Prompt";
`;

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 2rem;
  border-radius: 24px;
  width: 480px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  color: #123559;
  @media only screen and ${breakpoint.device.sm} {
    margin: 0 1rem;
  }
`;

export const FormControl = styled(Form.Control)`
  color: #123559;
  font-size: 16px;
`;

export const FormGroup = styled(Form.Group)`
  margin-top: 0.75rem;
  color: #123559;
  width: 100%;
  border-radius: 16px;

  h1 {
    font-size: 2rem;
    margin: 0;
    margin-bottom: 0.5rem;
    text-align: center;
    @media only screen and ${breakpoint.device.sm} {
      font-size: 1.5rem;
    }
  }

  h2 {
    font-size: 1.5rem;
    text-align: center;
    @media only screen and ${breakpoint.device.sm} {
      font-size: 1.25rem;
    }
  }
`;

export const ButtonLogin = styled(Button)`
  display: flex;
  position: relative;
  width: 100%;
  padding: 0.15rem 0.5rem;
  background-color: #0984e3;
  color: #fff;
  border-radius: 8px;
  font-size: 18px;
  margin-top: 1.5rem;
  margin-bottom: 0.25rem;
  height: ${(props: { isLoading: boolean }) =>
    props.isLoading ? "3.5rem" : "fit-content"};
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
`;
